import PriceDisplay from 'components/GlobalModals/SavedForLaterModal/PriceDisplay/PriceDisplay.f';

export default PriceDisplay;
